
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsCategoryGrid extends Serenity.EntityGrid<CsCategoryRow, any> {
        protected getColumnsKey() { return CsCategoryColumns.columnsKey; }
        protected getDialogType() { return CsCategoryDialog; }
        protected getIdProperty() { return CsCategoryRow.idProperty; }
        protected getInsertPermission() { return CsCategoryRow.insertPermission; }
        protected getLocalTextPrefix() { return CsCategoryRow.localTextPrefix; }
        protected getService() { return CsCategoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}